<template lang="pug">
  v-card(v-if="form")
    v-card-title
      h2.card-title {{ 'base.edit_ingredient' | translate }}
    v-card-content
      v-select.mb-3(
        api-search
        label="base.type"
        :options="ingredientTypes"
        :value="form.ingredient_type && form.ingredient_type.id"
        @input="onTypeChange"
        @search="onIngredientTypeSearch")
      v-input.mb-3(
        :label="$t('base.name')"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        v-model="form.name")
      v-select.mb-3(
        :label="$t('base.stock')"
        :options="filteredStocks"
        v-model="form.stock.id")
      .toogle-wrap
        ui-toggle-unit(
          :tolerancePercent="form.tolerance_percent"
          :toleranceUnit="form.tolerance_unit"
          :toleranceKg="form.tolerance_kg"
          @update="onToleranceUpdate"
        )
      v-input.mb-3.mt-5(
        :label="$t('base.dry_metter')"
        :hint="errorMessage('dry_metter')"
        :float="true"
        :invalid="!!errorMessage('dry_metter')"
        type="text"
        pattern="^[0-9]+([.,][0-9]{0,2})?$"
        min="0"
        max="100"
        v-model="form.dry_matter")
      v-switch.mb-3(
        :label="$t('history.ignore_in_reports')"
        v-model="form.ignored_in_report")
      v-switch(
        :label="$t('history.autoload')"
        v-model="form.auto_load")
    v-card-actions
      v-btn.mr-2(
        :loading="loading"
        @click="onSubmit")
        | {{ 'base.save' | translate }}
      delete-btn(
        @delete="onDelete")
</template>

<script>
import api from '@/api'
import { mapGetters, mapActions } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
import UiToggleUnit from '@/components/ui/ui-toggle-unit/UiToggleUnit.vue'
import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'

export default {
  name: 'CreateNewModal',

  props: {
    data: {
      type: Object,
      required: true,
      default: null
    }
  },

  mixins: [formErrorsMixin],

  components: {
    DeleteBtn,
    UiToggleUnit
  },

  data: () => ({
    form: null,
    ingredientTypes: [],
    loading: false,
    errors: {
      name: null
    }
  }),

  mounted () {
    this.form = {
      ...this.data
    }
    this.onIngredientTypeSearch()
    this.loadStocks()
  },

  methods: {
    ...mapActions('stocks', [
      'loadStocks'
    ]),

    async onSubmit () {
      this.loading = true
      const { id, ...payload } = this.form
      // // Check if dry_matter exists and has a comma
      if (payload.dry_matter && typeof payload.dry_matter === 'string' && payload.dry_matter.includes(',')) {
        payload.dry_matter = payload.dry_matter.toString().replace(',', '.')
      }
      this.checkValidData()

      if (this.errors.name === null) {
        const { errors } = await api.ingredients.updateById(id, payload)
        this.errors = errors
        if (!errors) {
          this.$emit('update')
          this.$emit('close')
        }
      }
      this.loading = false
    },
    checkValidData () {
      this.errors.name = null
      if (!this.form.name) {
        this.errors.name = this.errors.name = ['3']
      } else if (this.form.name.length > 100) {
        this.errors.name = this.errors.name = ['6', 100]
      }
    },
    async onIngredientTypeSearch (value = null) {
      const params = {
        name: value,
        limit: 2500
      }
      const { data } = await api.ingredienttypes.litelist(params)
      this.ingredientTypes = data
    },

    onTypeChange (id) {
      this.form.ingredient_type = { id }
      const type = this.ingredientTypes.find(item => item.id === id)
      if (type) {
        this.form.name = type.name
      }
    },
    onToleranceUpdate (payload) {
      this.form.tolerance_kg = payload.tolerance_kg
      this.form.tolerance_percent = payload.tolerance_percent
      this.form.tolerance_unit = payload.tolerance_unit
    },

    async onDelete () {
      const { errors } = await api.ingredients.deleteById(this.form.id)
      if (!errors) {
        this.$emit('update', this.form.stock.id)
      }
      this.$emit('close')
    }
  },

  computed: {
    ...mapGetters('stocks', [
      'stocks'
    ]),

    filteredStocks () {
      return this.stocks
        .filter(item => (item.farm === null &&
          (item.company && item.company.id) === +this.$route.params.company_id) ||
          (item.farm && item.farm.id) === +this.$route.params.farm_id)
    }
  }
}
</script>
